import convertToArray from '../../utils/convertToArray';

export default (selector: string, context?: HTMLElement | Document): HTMLElement[] => {
  if (context) {
    return convertToArray(context.querySelectorAll(selector));
  }
  return [];
};
